export const PayData = [
  {id: 0, steps: "Pending", remarks: "Order Confirmed",  img: "", date: "28-12-2022"},
  {id: 1, steps: "Advance", remarks: "Pending",  img: "", date: "28-12-2022"},
  {id: 2, steps: "Partial", remarks: "Pending",  img: "", date: "28-12-2022" },
  {id: 3, steps: "Paid", remarks: "Pending",  img: "", date: "28-12-2022" },
]